import { StrictLocalizeFunction } from "../localization";

import { ISO_TO_COUNTRY_NAME_WITHOUT_SANCTIONS as _ISO_TO_COUNTRY_NAME_WITHOUT_SANCTIONS } from "./ISO_TO_COUNTRY_NAME";
import { PRIMARY_COUNTRIES_ISO_TO_COUNTRY_NAME } from "./PRIMARY_COUNTRIES_ISO_TO_COUNTRY_NAME";
import { THREE_LETTER_PRIMARY_COUNTRY_CODES } from "./THREE_LETTER_PRIMARY_COUNTRY_CODES";

const _ORDER = (strictLocalize: StrictLocalizeFunction) => {
  const ISO_TO_COUNTRY_NAME_WITHOUT_SANCTIONS =
    _ISO_TO_COUNTRY_NAME_WITHOUT_SANCTIONS(strictLocalize);
  return [
    ISO_TO_COUNTRY_NAME_WITHOUT_SANCTIONS[
      THREE_LETTER_PRIMARY_COUNTRY_CODES.USA
    ],
    ISO_TO_COUNTRY_NAME_WITHOUT_SANCTIONS[
      THREE_LETTER_PRIMARY_COUNTRY_CODES.GBR
    ],
    ISO_TO_COUNTRY_NAME_WITHOUT_SANCTIONS[
      THREE_LETTER_PRIMARY_COUNTRY_CODES.CAN
    ],
  ];
};

export const PRIMARY_COUNTRY = (strictLocalize: StrictLocalizeFunction) => {
  const ISO_TO_COUNTRY_NAME_WITHOUT_SANCTIONS =
    _ISO_TO_COUNTRY_NAME_WITHOUT_SANCTIONS(strictLocalize);
  const ORDER = _ORDER(strictLocalize);

  return Object.keys(PRIMARY_COUNTRIES_ISO_TO_COUNTRY_NAME(strictLocalize))
    .sort((firstCode, secondCode) => {
      const first =
        // @ts-expect-error FIXME(implicitAny): https://faire.link/no-implicit-any
        ISO_TO_COUNTRY_NAME_WITHOUT_SANCTIONS[firstCode];

      const second =
        // @ts-expect-error FIXME(implicitAny): https://faire.link/no-implicit-any
        ISO_TO_COUNTRY_NAME_WITHOUT_SANCTIONS[secondCode];
      const firstIndex = ORDER.findIndex((i) => i === first);
      const secondIndex = ORDER.findIndex((i) => i === second);

      if (firstIndex !== -1 && secondIndex !== -1) {
        return firstIndex - secondIndex;
      }

      if (firstIndex !== -1 || secondIndex !== -1) {
        return secondIndex - firstIndex;
      }

      return second > first ? -1 : 1;
    })
    .map((key) => ({
      value: key,
      // @ts-expect-error FIXME(implicitAny): https://faire.link/no-implicit-any
      label: ISO_TO_COUNTRY_NAME_WITHOUT_SANCTIONS[key],
    }));
};
